import React from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  isDiffusionModelsState,
  isPaintByExampleState,
  isSDState,
  settingState,
} from '../../store/Atoms.tsx'
import Modal from '../shared/Modal.tsx'
import ManualRunInpaintingSettingBlock from './ManualRunInpaintingSettingBlock.tsx'
import HDSettingBlock from './HDSettingBlock.tsx'
import ModelSettingBlock from './ModelSettingBlock.tsx'
import DownloadMaskSettingBlock from './DownloadMaskSettingBlock.tsx'
import useHotKey from '../../hooks/useHotkey.tsx'

declare module 'react' {
  interface InputHTMLAttributes<T> extends HTMLAttributes<T> {
    // extends React's HTMLAttributes
    directory?: string
    webkitdirectory?: string
  }
}

interface SettingModalProps {
  onClose: () => void
}

export default function SettingModal(props: SettingModalProps) {
  const { onClose } = props
  const [setting, setSettingState] = useRecoilState(settingState)
  const isSD = useRecoilValue(isSDState)
  const isDiffusionModels = useRecoilValue(isDiffusionModelsState)

  const handleOnClose = () => {
    setSettingState(old => {
      return { ...old, show: false }
    })
    onClose()
  }

  useHotKey(
    's',
    () => {
      setSettingState(old => {
        return { ...old, show: !old.show }
      })
    },
    {},
    []
  )

  return (
    <Modal
      onClose={handleOnClose}
      title="Settings"
      className="modal-setting"
      show={setting.show}
    >
      {/* <DownloadMaskSettingBlock /> */}
      {/* {isDiffusionModels ? <></> : <ManualRunInpaintingSettingBlock />} */}
      <ModelSettingBlock />
      {/* {isDiffusionModels ? <></> : <HDSettingBlock />} */}
    </Modal>
  )
}
